// src/pages/admin/components/Sidebar.js
import React from 'react';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import { Box, useMediaQuery } from '@mui/material';
import HomeIcon        from '@mui/icons-material/Home';
import ModeSharpIcon   from '@mui/icons-material/ModeSharp';
import AssignmentIcon  from '@mui/icons-material/Assignment';
import LogoutIcon      from '@mui/icons-material/Logout';

export const DRAWER_WIDTH_OPEN      = 260;
export const DRAWER_WIDTH_COLLAPSED = 70;
const APP_BAR_HEIGHT = 64; // Standard MUI AppBar-Höhe

function Sidebar({ open, onToggle }) {
  const navigate  = useNavigate();
  const isMobile  = useMediaQuery('(max-width:600px)');
  const width     = open ? DRAWER_WIDTH_OPEN : (isMobile ? 0 : DRAWER_WIDTH_COLLAPSED);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  const menuItems = [
    { label: 'Dashboard',          icon: <HomeIcon />,       path: '/dashboard' },
    { label: 'Homepage Anfragen',  icon: <AssignmentIcon />, path: '/dashboard/homepage-requests' },
    { label: 'Bewertungsanfragen', icon: <ModeSharpIcon />,  path: '/dashboard/homepage-req-edit' },
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width,
        flexShrink: 0,
        // Der Drawer-Wrapper nimmt die richtige Breite ein (kein overlap)
        [`& .MuiDrawer-paper`]: {
          width,
          boxSizing:   'border-box',
          overflowX:   'hidden',
          // ── Kernfix: Drawer beginnt UNTER der AppBar ──
          top:         `${APP_BAR_HEIGHT}px`,
          height:      `calc(100% - ${APP_BAR_HEIGHT}px)`,
          // Kein zIndex-Konflikt mit AppBar mehr nötig
          zIndex:      (theme) => theme.zIndex.drawer,
          backgroundColor: '#081627',
          color:        '#ffffff',
          display:      'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          transition:   (theme) =>
            theme.transitions.create('width', {
              easing:   theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        },
      }}
    >
      {/* Menü-Einträge */}
      <List sx={{ flexGrow: 1, pt: 1 }}>
        {menuItems.map(({ label, icon, path }) => (
          <ListItemButton
            key={path}
            onClick={() => navigate(path)}
            sx={{
              height: '53px',
              px: '24px',
              color: 'rgba(255,255,255,0.7)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.08)',
                color: '#4fc3f7',
              },
            }}
          >
            <ListItemIcon sx={{ color: 'inherit', minWidth: '40px' }}>
              {icon}
            </ListItemIcon>
            {open && (
              <ListItemText
                primary={label}
                primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
              />
            )}
          </ListItemButton>
        ))}
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', mt: 1 }} />
      </List>

      {/* Footer: Logout */}
      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', p: 1 }}>
        <ListItemButton
          onClick={handleLogout}
          sx={{
            color: 'rgba(255,255,255,0.7)',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.08)',
              color: '#4fc3f7',
            },
          }}
        >
          <ListItemIcon sx={{ color: 'inherit', minWidth: '40px' }}>
            <LogoutIcon />
          </ListItemIcon>
          {open && (
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
            />
          )}
        </ListItemButton>
      </Box>
    </Drawer>
  );
}

export default Sidebar;